export default "__VITE_ASSET__BMA5sD4t__"